import { Button, Flex, Modal, Typography } from "antd";
import Title from "antd/es/typography/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomTitle } from "../customTitle";
import Actions from "../../../redux/actions";
import { getSystemSettingsAction } from "../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import { useNavigate } from "react-router-dom";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { appConfig } from "../../../constants/config/appConfig";
import { userRoles } from "../../../constants";
import { useTranslation } from "react-i18next";

const SuspensionDialog = () => {
  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */
  const { t } = useTranslation("suspensionDialog");

  const navigate = useNavigate();

  /* loading dependencies */
  const [loading, setLoading] = useState(false);

  /* perform delete action */
  const handleClose = () => {
    navigate(baseRouteMaker(routes.FINE_PAYMENT));
    dispatch(Actions.createAction(Actions.SUSPEND_DIALOG_CLOSE));
  };

  const user = useSelector((state) => state?.auth?.loginDetails);
  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);
  const isOrgSuspended = user?.organization_id?.status;

  const fineAmount = useSelector(
    (state) => state?.addonAndSponsorship?.systemSettings
  );

  const isSuspendDialogOpen = useSelector(
    (state) => state.common.suspendDialog
  );

  useEffect(() => {
    dispatch(getSystemSettingsAction(setLoading));
    if (
      user &&
      user?.role === userRoles.SERVICE_PROVIDER_ADMIN &&
      isOrgSuspended !== undefined &&
      isOrgSuspended === "suspended"
    ) {
      dispatch(Actions.createAction(Actions.SUSPEND_DIALOG_OPEN));
    }
  }, [user]);

  return (
    <Modal
      open={isSuspendDialogOpen}
      closeIcon={<></>}
      maskClosable={false}
      footer={false}
      confirmLoading={loading}
      closable={false}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("Account Suspension Notice")}
        </CustomTitle>
        <Typography level={2}>
          {t("SuspendMessage1")}
          <strong>{`${
            fineAmount?.organization_account_fine_percentage
          } ${String(fineAmount?.system_currency).toUpperCase()} `}</strong>
          {t("SuspendMessage2")}
        </Typography>
        <Flex gap="1rem" align="center" justify="center">
          <Button type="primary" onClick={handleClose}>
            {t("Pay Fine")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default SuspensionDialog;
